// extracted by mini-css-extract-plugin
export default {"admin_wp":"AddCourse_admin_wp__V2kyN","one_course":"AddCourse_one_course__5iPS2"};